"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderLayout;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _images = require("../common_features/assets/images");
var _reactBootstrap = require("react-bootstrap");
var _Header = require("@ccw-pwa-ui/Header");
var _reactResponsive = require("react-responsive");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _NotificationPreferences = _interopRequireDefault(require("../containers/NotificationPreferences"));
var _CreateProfile = _interopRequireDefault(require("../containers/CreateProfile"));
var _ForceChangePassword = _interopRequireDefault(require("../containers/ForceChangePassword"));
function HeaderLayout() {
  const isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: 992
  });
  const isPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(orientation: portrait)'
  });
  const type = isDesktop && !isPortrait;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_Header.Header, {
    style: {
      position: 'fixed',
      zIndex: "99",
      height: "80px"
    },
    type: type ? "Desktop" : '',
    imageUrl: type ? _images.Pentair_Logo_white.default : _images.Pentair_Logo.default,
    rightText: type ? 'Provide your business with clean, clear, expertly managed water' : '',
    rightTextStyle: {
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '28px',
      color: '#ffffff'
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.basePath.path,
    element: /*#__PURE__*/_react.default.createElement(_CreateProfile.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.createProfile.path,
    element: /*#__PURE__*/_react.default.createElement(_CreateProfile.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.forceChangePassword.path,
    element: /*#__PURE__*/_react.default.createElement(_ForceChangePassword.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.NotificationPreferencesOnboard.path,
    element: /*#__PURE__*/_react.default.createElement(_NotificationPreferences.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.basePath.path,
    element: /*#__PURE__*/_react.default.createElement(_reactRouterDom.Navigate, {
      to: "/"
    })
  })))));
}